module.exports = __webpack_public_path__ + "static/img/321_TO8_2497.a4dd0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/321_TO8_2497.jpg
// module id = ga3i
// module chunks = 0